import React, { useState, useEffect, useRef, useContext } from "react";
import { Shimmer, Image } from "react-shimmer";
import { Link, useParams } from "react-router-dom";
import Marquee from "react-fast-marquee";

import styles from "./index.module.css";
import offer from "../../assets/offer.png";
import { api_call } from "../../utils/Network";
import Carousels from "../../components/Carousel/Carousel";
import {
  appendImageUrl,
  getSavedData,
  saveLocalData,
  isMobiledevice,
} from "../../utils/helperFunctions";
import { MainContext } from "../../utils/context";
import COUNTBANNER from "../../assets/countBanner.png";
import COUNT0 from "../../assets/count.png";
import COUNT1 from "../../assets/count1.png";
import COUNT2 from "../../assets/count2.png";
import COUNT3 from "../../assets/count3.png";
import COUNT4 from "../../assets/count4.png";
import COUNT5 from "../../assets/count5.png";
import COUNT6 from "../../assets/count6.png";
import COUNT7 from "../../assets/count7.png";
import COUNT8 from "../../assets/count8.png";
import COUNT9 from "../../assets/count9.png";
import GalleryView from "../GalleryView";

const countImg = {
  COUNT0,
  COUNT1,
  COUNT2,
  COUNT3,
  COUNT4,
  COUNT5,
  COUNT6,
  COUNT7,
  COUNT8,
  COUNT9,
};

const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("safari") > -1 && ua.indexOf("chrome") < 0;
};

function Home() {
  const { setCurrentPath } = useContext(MainContext);
  const [categoryList, setCategoryList] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [categoryIdSelected, setCategoryIdSelected] = useState(0);
  const [banner, setBanner] = useState("");
  const [shouldUseImage, setShouldUseImage] = useState(false);
  const [heroes, setHeroes] = useState([]);
  const [offers, setOffers] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [verticals, setVerticals] = useState([]);
  const videoParentRef = useRef();
  const testimonialRef = useRef(null);
  const verticalRef = useRef(null);
  const { type } = useParams();
  const [countValue, setCountValue] = useState([]);

  useEffect(() => {
    if (testimonials.length) {
      setCurrentPath("/");
      if (type === "testimonial")
        testimonialRef.current.scrollIntoView({ behavior: "smooth" });
      else if (type === "vertical")
        verticalRef.current.scrollIntoView({ behavior: "smooth" });
      // else window.scrollTo(0, 0);
    }
  }, [testimonials, verticals, , type]);

  useEffect(() => {
    if (getSavedData("homeBanner")) setBanner(getSavedData("homeBanner"));
    if (getSavedData("categoryData")) {
      const categories = getSavedData("categoryData");
      if (categories.length) {
        setCategoryList(categories);
        setVariantList(categories[0].variant);
        setCategoryIdSelected(categories[0].category_id);
      }
    }
    if (getSavedData("heroData")) setHeroes(getSavedData("heroData"));
    getBanner();
    getCategoryData();
    // getOffers();
    getHeroes();
    // getSubscriptions();
    getTestimonials();
    getVentures();
  }, []);

  useEffect(() => {
    if (isSafari() && videoParentRef.current) {
      const player = videoParentRef.current.children[0];
      if (player) {
        player.controls = false;
        player.playsinline = true;
        player.muted = true;
        player.setAttribute("muted", "");
        player.autoplay = true;
        setTimeout(() => {
          const promise = player.play();
          if (promise.then) {
            promise
              .then(() => {})
              .catch(() => {
                videoParentRef.current.style.display = "none";
                setShouldUseImage(true);
              });
          }
        }, 0);
      }
    }
  }, []);

  const getBanner = () => {
    api_call
      .get(`/service_list/info/landing_page/banner/`)
      .then((response) => {
        const data = response.data.data;
        if (isMobiledevice()) setBanner(appendImageUrl(data.banner2));
        else setBanner(appendImageUrl(data.banner1));
        if (response.data.counter?.numbers) {
          const counts = response.data.counter?.numbers?.toString().split("");
          setTimeout(() => setCountValue(counts), 2000);
        }
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const getCategoryData = () => {
    api_call
      .get("/service_list/category/")
      .then((response) => {
        const categories = response.data.data;
        saveLocalData("categoryData", categories);
        if (categories.length) {
          setCategoryList(categories);
          setVariantList(categories[0].variant);
          setCategoryIdSelected(categories[0].category_id);
        }
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const getOffers = () => {
    api_call
      .get("/service_list/info/offer/")
      .then((response) => {
        saveLocalData("offerData", response.data.data);
        // setOffers(response.data.data);
      })
      .catch((e) => console.log(e));
  };

  const getHeroes = () => {
    api_call
      .get("/service_list/info/squad/")
      .then((response) => {
        saveLocalData("heroData", response.data.data);
        setHeroes(response.data.data);
      })
      .catch((error) => console.log(error));
  };

  const getSubscriptions = () => {
    api_call
      .get("/service_list/info/all_subscriptions/")
      .then((response) => {
        saveLocalData("subscriptionData", response.data.data);
        setSubscriptions(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTestimonials = () => {
    api_call
      .post(`auth/ratings/view_review/`, {})
      .then((response) => {
        const data = response.data.data;
        setTestimonials(data);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const getVentures = () => {
    api_call
      .get(`service_list/facility/`)
      .then((response) => {
        const data = response.data.data;
        if (data?.length) setVerticals(data);
      })
      .catch((error) => {
        console.log(error.response, "Error occured");
      });
  };

  const categorySelectHandler = (categoryId = 0, allVariants = []) => {
    setCategoryIdSelected(categoryId);
    setVariantList(allVariants);
  };

  return (
    <>
      <div className={styles.banner}>
        {shouldUseImage ? (
          <img className={styles.bannerVideo} src={banner} alt="Muted Video" />
        ) : (
          <div
            className={styles.bannerVideo}
            ref={videoParentRef}
            dangerouslySetInnerHTML={{
              __html: `
                  <video class="${styles.bannerVideo}" loop muted autoplay playsinline preload="metadata">
                    <source src="${banner}" type="video/mp4" />
                  </video>`,
            }}
          />
        )}
      </div>
      <div style={{ backgroundColor: "#4d3060" }}>
        <div className={styles.categoryBar}>
          {categoryList &&
            categoryList !== undefined &&
            categoryList.map((cat) => (
              <div
                key={cat.category_id}
                className={styles.category}
                onClick={() =>
                  categorySelectHandler(cat.category_id, cat.variant)
                }
              >
                <div
                  style={{
                    backgroundColor:
                      categoryIdSelected === cat.category_id
                        ? "#f4c53d"
                        : "#fff",
                  }}
                  className={styles.activ}
                ></div>
                <Image
                  src={appendImageUrl(
                    cat.category_icon
                      ? cat.category_icon
                      : "/files/files/Group_62_3lSnHAp.png"
                  )}
                  NativeImgProps={{
                    style: { objectFit: "contain", height: 36, width: 36 },
                  }}
                  fallback={<Shimmer width={36} height={36} />}
                  errorFallback={() => <Shimmer width={36} height={36} />}
                />
                <h4 style={{ margin: 0 }}>{cat.category_name}</h4>
              </div>
            ))}
        </div>
      </div>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          {variantList.map(
            (vr, i) =>
              i < 2 && (
                <Link
                  style={{ textDecoration: "none" }}
                  className={styles.variant}
                  key={i}
                  to={`/cart/${categoryIdSelected}/${vr.variant_id}/0`}
                >
                  <h3 className={styles.variantText}>{vr.sub_category}</h3>
                  <div className={styles.vrImgC}>
                    <Image
                      src={appendImageUrl(
                        vr.variant_icon
                          ? vr.variant_icon
                          : "/files/files/Rectangle_82x_vjBatSf.png"
                      )}
                      NativeImgProps={{ className: styles.variantImage }}
                      fallback={
                        <Shimmer
                          height={120}
                          width={isMobiledevice() ? 160 : 240}
                          className={styles.variantImage}
                        />
                      }
                    />
                  </div>
                </Link>
              )
          )}
        </div>
        <>
          {/* <h3 className={styles.mainText}>Service Count</h3> */}
          <div className={styles.countBanner}>
            <img src={COUNTBANNER} alt="service_count" width="100%" />
            <div className={styles.horticulture}>
              <div style={{ display: "flex", marginBottom: "3%" }}>
                {[1, 2, 3, 4, 5, 6, 7].map((a) => (
                  <Marquee
                    style={{
                      width: isMobiledevice() ? 28 : 100,
                      height: isMobiledevice() ? 28 : 100,
                      transform: "rotate(90deg)",
                    }}
                    play
                    speed={100}
                    loop={countValue.length ? 1 : 0}
                    gradient={false}
                    key={a}
                  >
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
                      <img
                        key={i}
                        style={{
                          width: isMobiledevice() ? 28 : 100,
                          height: isMobiledevice() ? 20 : 80,
                          transform: "rotate(-90deg)",
                        }}
                        src={
                          countImg[
                            `COUNT${countValue.length ? countValue[a - 1] : i}`
                          ]
                        }
                        alt="count"
                      />
                    ))}
                  </Marquee>
                ))}
              </div>
              <h3>Sq. Ft. Area Serviced & Counting...</h3>
            </div>
          </div>
        </>
        {offers && offers.length > 0 && (
          <>
            <h3 className={styles.mainText}>Top Offers</h3>
            <div className={styles.container}>
              {offers.map((ofr) => (
                <div key={ofr.offer_id} className={styles.offer}>
                  <div className={styles.offerCard}>
                    <span className={styles.offerName}>Offer Name</span>
                    <p>
                      {ofr.offer_description}
                      Contrary to popular Ipsum is simply random text. It has
                      roots in piece
                    </p>
                    <div className={styles.coupon}>
                      <span className={styles.couponText}>Use Code</span>
                      <span className={styles.couponName}>
                        {ofr.coupon_code?.slice(0, 12)}
                      </span>
                    </div>
                  </div>
                  <img className={styles.offerImg} src={offer} alt="offer" />
                </div>
              ))}
            </div>
          </>
        )}
        {heroes && heroes.length > 0 && (
          <>
            <h3 className={styles.mainText}>Our Heroes</h3>
            <div className={styles.squards}>
              <Carousels sqd={heroes} />
            </div>
          </>
        )}
        <div style={{ marginBottom: "3%" }}>
          {subscriptions.length > 0 && (
            <>
              <h3 style={{ margin: "30px 0" }} className={styles.mainText}>
                Subscriptions
              </h3>
              <div className={styles.container}>
                {subscriptions.map((subs) => (
                  <div key={subs.id} className={styles.subscription}>
                    <span className={styles.subscriptionName}>
                      {subs.subscription_name}
                    </span>
                    <div className={styles.priceOff}>
                      <span className={styles.mrp}>₹2000</span>
                      <span className={styles.off}>Save {subs.discount}%</span>
                    </div>
                    <span className={styles.price}>₹1000</span>
                    <span className={styles.mo}>/mo</span>
                    <div className={styles.list}>
                      <ul>
                        <li>{subs.description}</li>
                        {[1, 2, 3, 4].map((a) => (
                          <li key={a}>It has root piece of Latin</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div style={{ marginBottom: "3%" }} ref={testimonialRef}>
          {testimonials && testimonials.length > 0 && (
            <>
              <h3 className={styles.mainText}>Testimonials</h3>
              <div className={styles.squards}>
                <Carousels sqd={[...testimonials]} />
              </div>
            </>
          )}
        </div>
        <div style={{ marginBottom: "3%" }} ref={verticalRef}>
          {verticals && verticals.length > 0 && (
            <>
              <h3 className={styles.mainText}>Verticals @ GRF</h3>
              <div className={styles.squards}>
                <Carousels sqd={verticals} />
              </div>
            </>
          )}
        </div>
        <div>
        <h3 className={styles.mainText}>Gallery</h3>
          <GalleryView />
        </div>
      </div>
    </>
  );
}

export default Home;
